// Warenkorb im Header (gespeicherte Buchungen mit Erinnerungs-Mails). Flache Schlüssel, wird in fieldMapping.js eingemischt.
const de = {
  cart_esim: "eSIM für Ihre Reise",
  cart_esim_days: "Tage",
  pay_too_late: "Die Zahlung per Karte ist nur bis {hours} Stunden vor der Abholung möglich und leider nicht mehr verfügbar. Bitte zahlen Sie wie gebucht (bar bzw. mit Karte beim Fahrer).",
  pay_until: "Online per Karte zahlen noch bis",
  price_changed: "Der Preis hat sich geändert",
  price_changed_hint: "Seit Ihrer letzten Eingabe wurden Preise angepasst. Neuer Preis:",
  cart_price_lock: "Preis garantiert bis",
  addr_keep: "Eigene Eingabe behalten",
  addr_your_input: "Ihre Eingabe",
  addr_use: "Vorschlag übernehmen",
  addr_edit: "Zurück zur Eingabe",
  addr_suggest_title: "Wir konnten diese Adresse nicht eindeutig bestätigen. Meinten Sie:",
  cart_via: "über",
  cart_unavailable: "Dieses Angebot ist nicht mehr verfügbar. Bitte suchen Sie neu.",
  cart_busy: "Wird geladen …",
  cart_title: "Warenkorb",
  cart_empty: "Ihr Warenkorb ist leer.",
  cart_continue: "Fortsetzen",
  cart_remove: "Entfernen",
  cart_expired: "Abfahrt überschritten",
  cart_hint: "Solange die Abfahrt noch nicht überschritten ist, erinnern wir Sie per E-Mail.",
  cart_round: "Hin & zurück",
  cart_one: "Einfache Fahrt",
  cart_loading: "Lädt …",
};
const en = {
  cart_esim: "eSIM for your trip",
  cart_esim_days: "days",
  pay_too_late: "Card payment is only possible up to {hours} hours before pickup and is no longer available. Please pay as booked (cash or card to the driver).",
  pay_until: "Pay online by card until",
  price_changed: "The price has changed",
  price_changed_hint: "Prices were updated since your last visit. New price:",
  cart_price_lock: "Price guaranteed until",
  addr_keep: "Keep my entry",
  addr_your_input: "Your entry",
  addr_use: "Use suggestion",
  addr_edit: "Back to editing",
  addr_suggest_title: "We could not clearly confirm this address. Did you mean:",
  cart_via: "via",
  cart_unavailable: "This offer is no longer available. Please search again.",
  cart_busy: "Loading …",
  cart_title: "Cart",
  cart_empty: "Your cart is empty.",
  cart_continue: "Continue",
  cart_remove: "Remove",
  cart_expired: "Departure has passed",
  cart_hint: "We will remind you by email as long as the departure has not passed.",
  cart_round: "Round trip",
  cart_one: "One way",
  cart_loading: "Loading …",
};
const tr = {
  cart_esim: "Seyahatiniz için eSIM",
  cart_esim_days: "gün",
  pay_too_late: "Kartla ödeme yalnızca alış saatinden {hours} saat öncesine kadar mümkündür ve artık kullanılamaz. Lütfen rezervasyonda belirtildiği gibi ödeyin (nakit veya sürücüye kartla).",
  pay_until: "Çevrimiçi kartla ödeme son tarih:",
  price_changed: "Fiyat değişti",
  price_changed_hint: "Son ziyaretinizden bu yana fiyatlar güncellendi. Yeni fiyat:",
  cart_price_lock: "Fiyat garantisi:",
  addr_keep: "Kendi girdiğimi koru",
  addr_your_input: "Girdiğiniz adres",
  addr_use: "Öneriyi kullan",
  addr_edit: "Düzenlemeye dön",
  addr_suggest_title: "Bu adresi net olarak doğrulayamadık. Şunu mu demek istediniz:",
  cart_via: "üzerinden",
  cart_unavailable: "Bu teklif artık mevcut değil. Lütfen yeniden arayın.",
  cart_busy: "Yükleniyor …",
  cart_title: "Sepet",
  cart_empty: "Sepetiniz boş.",
  cart_continue: "Devam et",
  cart_remove: "Kaldır",
  cart_expired: "Kalkış zamanı geçti",
  cart_hint: "Kalkış zamanı geçmediği sürece size e-posta ile hatırlatırız.",
  cart_round: "Gidiş-dönüş",
  cart_one: "Tek yön",
  cart_loading: "Yükleniyor …",
};
const pl = {
  cart_esim: "eSIM na podróż",
  cart_esim_days: "dni",
  pay_too_late: "Płatność kartą jest możliwa tylko do {hours} godzin przed odbiorem i nie jest już dostępna. Zapłać zgodnie z rezerwacją (gotówką lub kartą u kierowcy).",
  pay_until: "Płatność kartą online do",
  price_changed: "Cena uległa zmianie",
  price_changed_hint: "Od Twojej ostatniej wizyty ceny zostały zaktualizowane. Nowa cena:",
  cart_price_lock: "Cena gwarantowana do",
  addr_keep: "Zachowaj mój wpis",
  addr_your_input: "Twój wpis",
  addr_use: "Użyj sugestii",
  addr_edit: "Wróć do edycji",
  addr_suggest_title: "Nie udało się jednoznacznie potwierdzić tego adresu. Czy chodziło o:",
  cart_via: "przez",
  cart_unavailable: "Ta oferta nie jest już dostępna. Wyszukaj ponownie.",
  cart_busy: "Ładowanie …",
  cart_title: "Koszyk",
  cart_empty: "Twój koszyk jest pusty.",
  cart_continue: "Kontynuuj",
  cart_remove: "Usuń",
  cart_expired: "Odjazd minął",
  cart_hint: "Przypominamy e-mailem, dopóki odjazd nie minie.",
  cart_round: "W obie strony",
  cart_one: "W jedną stronę",
  cart_loading: "Ładowanie …",
};
const uk = {
  cart_esim: "eSIM для подорожі",
  cart_esim_days: "дн.",
  pay_too_late: "Оплата карткою можлива лише за {hours} годин до посадки і більше недоступна. Будь ласка, оплатіть, як було заброньовано (готівкою або карткою водієві).",
  pay_until: "Оплата карткою онлайн до",
  price_changed: "Ціна змінилася",
  price_changed_hint: "З часу вашого останнього візиту ціни було оновлено. Нова ціна:",
  cart_price_lock: "Ціна гарантована до",
  addr_keep: "Залишити мій ввід",
  addr_your_input: "Ваш ввід",
  addr_use: "Прийняти пропозицію",
  addr_edit: "Повернутися до редагування",
  addr_suggest_title: "Не вдалося однозначно підтвердити цю адресу. Ви мали на увазі:",
  cart_via: "через",
  cart_unavailable: "Ця пропозиція більше недоступна. Будь ласка, шукайте знову.",
  cart_busy: "Завантаження …",
  cart_title: "Кошик",
  cart_empty: "Ваш кошик порожній.",
  cart_continue: "Продовжити",
  cart_remove: "Видалити",
  cart_expired: "Час відправлення минув",
  cart_hint: "Ми нагадуватимемо електронною поштою, доки час відправлення не минув.",
  cart_round: "Туди й назад",
  cart_one: "В один бік",
  cart_loading: "Завантаження …",
};
export default { de, en, tr, pl, uk };
